// src/apiConfig.js
const API_BASE = '/api';
export default API_BASE;
